import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "112",
  height: "112",
  viewBox: "0 0 112 112",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M112 0H0V112H112V0Z",
      fill: "#D7DBF7"
    }, null, -1),
    _createElementVNode("path", {
      d: "M80.4069 46.1067L58.9869 24.6867C58.5996 24.2858 58.1355 23.9671 57.6224 23.7494C57.1093 23.5317 56.5576 23.4195 56.0002 23.4195C55.4429 23.4195 54.8912 23.5317 54.3781 23.7494C53.8649 23.9671 53.4009 24.2858 53.0136 24.6867L31.5936 46.1067C31.0061 46.7004 30.6068 47.4542 30.4456 48.2737C30.2844 49.0933 30.3684 49.9422 30.6872 50.7142C31.0059 51.4862 31.5453 52.1471 32.2378 52.6141C32.9302 53.0812 33.745 53.3337 34.5802 53.34H44.8002V84.5133C44.8125 85.6439 45.2703 86.724 46.0741 87.519C46.8779 88.3141 47.963 88.7601 49.0936 88.76H63.0936C64.2242 88.7601 65.3092 88.3141 66.113 87.519C66.9169 86.724 67.3746 85.6439 67.3869 84.5133V53.34H77.6069C78.4263 53.2987 79.2162 53.021 79.8811 52.5404C80.546 52.0597 81.0574 51.3968 81.3536 50.6317C81.6498 49.8666 81.718 49.0321 81.55 48.2291C81.382 47.426 80.9849 46.6889 80.4069 46.1067V46.1067Z",
      fill: "#151F6D"
    }, null, -1)
  ])))
}
export default { render: render }